module.exports = __webpack_public_path__ + "img/about-pic-5.d7656173.jpg";